// extracted by mini-css-extract-plugin
export default {"lightPanel":"chartPanel_lightPanel__NycuW","darkPanel":"chartPanel_darkPanel__oi-Dg"};